import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class NotificationSettings extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "NotificationSettings";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {

      emails: {
        style: {
          header_image_url: 'https://v2-styler.apps.qorcommerce.io/img/headers/black-1.jpg',

        },
        autopay_token_authorization: {
          name: null,
          description: null,
          subject: null,
          body: null,
        },
      },

      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    return data;
  }
}
